import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { withStyles } from "@mui/styles";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TableFooter,
  FormControl,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DebouncedTextField from "common/components/DebouncedTextField";
import Panel from "common/components/Panel";
import Resource from "common/components/Resource";
import Pagination from "common/components/Pagination";
import client from "common/admin/client";
import Snackbar from "@mui/material/Snackbar";

class ListBusinesses extends React.Component {
  state = {
    search: "",
    snackbar: "",
    categories: [],
    communities: [],
    buildings: [],
  };

  handleSearchChange = (value) => this.setState({ search: value });

  handleSnackbarClose = () => this.setState({ snackbar: null });

  async componentDidMount() {
    try {
      const communities = await client.get("communities", {
        query: { pagination: false },
      });
      const categories = await client.get("categories", {
        query: { pagination: false },
      });
      const buildings = await client.get("buildings", {
        query: { pagination: false },
      });
      this.setState({ communities, categories, buildings });
    } catch (e) {
      this.setState({
        snackbar: "Something went wrong, please try reloading.",
      });
    }
  }

  getCommunity = (id) => {
    const community = this.state.communities.find(
      (community) => community.id === id,
    );
    return community ? community.name : id;
  };

  getCategory = (id) => {
    const category = this.state.categories.find(
      (category) => category.id === id,
    );
    return category ? category.name : id;
  };

  getBuilding = (id) => {
    const building = this.state.buildings.find(
      (building) => building.id === id,
    );
    return building ? building.name : id;
  };

  render() {
    const { classes, match, history } = this.props;
    const { search } = this.state;
    const queryParams = {};
    if (search) {
      queryParams.name_like = search;
    }

    return (
      <Panel title="View Businesses">
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={!!this.state.snackbar}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          message={<span>{this.state.snackbar}</span>}
        />
        <Grid container direction="column" spacing={2}>
          <Grid size={{ xs: 4 }}>
            <FormControl className={classes.search}>
              <DebouncedTextField
                id="search"
                label="Search by name"
                onChange={this.handleSearchChange}
                delay={500}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Resource
          name="businesses"
          queryParams={queryParams}
          render={(businesses, { removeOne, prevPage, nextPage, page }) => (
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Neighborhood</TableCell>
                  <TableCell>Building</TableCell>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {businesses.length ? (
                  businesses.map((business) => (
                    <TableRow hover key={business.id}>
                      <TableCell>{business.id}</TableCell>
                      <TableCell
                        className={classes.clickable}
                        onClick={() =>
                          history.push(`${match.url}/${business.id}`)
                        }
                      >
                        {business.name}
                      </TableCell>
                      <TableCell>
                        {this.getCategory(business.category_id)}
                      </TableCell>
                      <TableCell>
                        {this.getCommunity(business.community_id)}
                      </TableCell>
                      <TableCell>
                        {business.building_id
                          ? this.getBuilding(business.building_id)
                          : ""}
                      </TableCell>
                      <TableCell>
                        {moment(business.updated_at).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell>
                        <IconButton>
                          <DeleteIcon onClick={() => removeOne(business.id)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7}>No additional data found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={7} className={classes.pagination}>
                    <Pagination
                      page={page}
                      nextPage={nextPage}
                      prevPage={prevPage}
                      items={businesses}
                    />
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          )}
        />
      </Panel>
    );
  }
}

const styles = (theme) => ({
  clickable: {
    cursor: "pointer",
    color: theme.palette.primary.light,
    fontWeight: "bold",
  },
  table: {
    minWidth: 700,
  },
  pagination: {
    textAlign: "right",
  },
  search: {
    paddingTop: theme.spacing(1),
  },
});

ListBusinesses.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListBusinesses);
